import { render, staticRenderFns } from "./NewConversationList.vue?vue&type=template&id=1bd01b5a&scoped=true&"
import script from "./NewConversationList.vue?vue&type=script&lang=ts&"
export * from "./NewConversationList.vue?vue&type=script&lang=ts&"
import style0 from "./NewConversationList.vue?vue&type=style&index=0&id=1bd01b5a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bd01b5a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/cypher.team.viz/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1bd01b5a')) {
      api.createRecord('1bd01b5a', component.options)
    } else {
      api.reload('1bd01b5a', component.options)
    }
    module.hot.accept("./NewConversationList.vue?vue&type=template&id=1bd01b5a&scoped=true&", function () {
      api.rerender('1bd01b5a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Chat/NewConversationList.vue"
export default component.exports